import { render, staticRenderFns } from "./Homelesson.vue?vue&type=template&id=f16c27be&scoped=true&"
import script from "./Homelesson.vue?vue&type=script&lang=js&"
export * from "./Homelesson.vue?vue&type=script&lang=js&"
import style0 from "./Homelesson.vue?vue&type=style&index=0&id=f16c27be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16c27be",
  null
  
)

export default component.exports